import React from "react";
import BannerOne from "../components/BannerOne";
import FeatureOne from "../components/FeatureOne";
import PromotionalOne from "../components/PromotionalOne";
import FlashSalesOne from "../components/FlashSalesOne";
import ProductListOne from "../components/ProductListOne";
import OfferOne from "../components/OfferOne";
import DeliveryOne from "../components/DeliveryOne";
import NewArrivalOne from "../components/NewArrivalOne";

const HomePageOne = () => {
  return (
    <>
      <BannerOne />
      <FeatureOne />
      <PromotionalOne />
      <FlashSalesOne />
      <ProductListOne />
      <OfferOne />
      <NewArrivalOne />
      <DeliveryOne />
    </>
  );
};

export default HomePageOne;